import React, {useEffect, useState} from 'react';
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";
import DynaSelectBox from "../../../DynaView/DynaSelectBox";
import Loader from "../../../../Loader";
import {ArrowIcon} from "../../ExportIcons/ExportIcons";

const LeadCase = ({initialData, leadIdFromList, setInitialData}) => {

  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    leadId: ""
  })
  const [leadInformation, setLeadInformation] = useState({
    full_name: "",
    mobile: "",
    telephone: "",
    documentList: []
  })

  const getInitialData = async () => {
    const response = await _axios.get(prefixUrl() + "/sadenMarketingCRM/?request=followUpFormData")
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  const getLeadInformation = async () => {
    const response = await _axios.get(prefixUrl() + "/sadenMarketingCRM/?request=leadDocument&leadId=" + sendData?.leadId)
    if (response?.data?.status) {
      setLeadInformation({...response.data.data.leadData, documentList: response?.data.data?.document})
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    if (Object.keys(initialData).length === 0) {
      void getInitialData()
    } else {
      setIsLoad(true)
    }
  }, []);

  useEffect(() => {
    if (isLoad && leadIdFromList !== "") {
      setSendData({...sendData, leadId: leadIdFromList.toString()})
    }
  }, [isLoad]);

  useEffect(() => {
    if (sendData?.leadId !== "") {
      void getLeadInformation()
    }
  }, [sendData?.leadId]);

  useEffect(() => {
    if (Object.keys(initialData).length === 0) {
      void getInitialData()
    } else {
      setIsLoad(true)
    }
  }, []);

  try {
    return (
      <>
        {isLoad ?
          <div className={"lead-follow-ups"}>
            <div className={"box-filter"}>
              <DynaSelectBox options={initialData?.leadIdArray}
                             hasFilter={true}
                             label={"کد لید"}
                             className={"solid-dyna-input"}
                             value={sendData?.leadId}
                             onChange={(data) => setSendData({
                               ...sendData,
                               leadId: data.value,
                             })}
              />
              {sendData?.leadId !== "" &&
                <>
                  <div className={"inline-text-row"}>
                    <h6>نام و نام خانوادگی : </h6>
                    <h6>{leadInformation?.full_name}</h6>
                  </div>
                  <div className={"inline-text-row"}>
                    <h6>شماره موبایل : </h6>
                    <h6>{leadInformation?.mobile}</h6>
                  </div>
                  <div className={"inline-text-row"}>
                    <h6>تلفن ثابت : </h6>
                    <h6>{leadInformation?.telephone}</h6>
                  </div>
                </>}
            </div>
            {sendData?.leadId !== "" &&
              <div className={"parent-follow-box"}>
                <div className={"inline-text-row"}>
                  <ArrowIcon/>
                  <h5>وضعیت پیگیری</h5>
                </div>
                <div className="text-box-lead">
                  {leadInformation?.documentList.length > 0 ? (
                    leadInformation.documentList.map((item, index) => (
                      <h6 key={index}>
                        {` تاریخ : ${item.date} -  ساعت : ${item.time} - بازاریاب : ${item?.marketer} -  توضیحات : ${item.description.trim()}`}
                      </h6>
                    ))
                  ) : (
                    <h6>پرونده ای ثبت نشده است.</h6>
                  )}
                </div>
              </div>
            }
          </div> : <Loader/>}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default LeadCase;